import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { getIn } from "formik"
import {
  updateCategoryClaimData,
  formIsValidUpdate,
} from "../../../../Redux/WindscreenClaim/actions"
import { useDispatch } from "react-redux"
import FormLabel from "../../../shared/formLabel"
import NumberFormat from "react-number-format"

function FormMobileTextBox(props) {
  const {
    textDesc,
    form,
    field,
    maxLength,
    coverageCategory,
    coverageCode,
    formName,
    clickedNext,
    //toUpperCase,
  } = props

  const dispatch = useDispatch()
  const errorsMsg = getIn(form.errors, field.name)
  // const isValid = formIsValid

  //const touched = getIn(form.touched, field.name)

  const handleTextChange = (event, error, category, coverageCode) => {
    // console.log(form)
    // console.log(field)

    const inputName = event.target.name
    const inputValue = event.target.value

    dispatch(
      updateCategoryClaimData(category, coverageCode, inputName, inputValue)
    )

    form.resetForm()
    form.validateForm().then(errors => {
      if (Object.entries(errors).length === 0) {
        dispatch(formIsValidUpdate(formName, true))
      } else {
        dispatch(formIsValidUpdate(formName, false))
      }
    })
  }

  const inputErrorClassName = (touched, errors, inputName) => {
    // return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    return (clickedNext && errors[inputName]) ||
      (errors[inputName] && touched[inputName]) ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px mobileInput">
          <Col
            xs={3}
            md={3}
            className={
              "mobilePrefix "
              // +
              // (form.errors[field.name] && form.touched[field.name]
              //   ? "mobileError"
              //   : "")
            }
          >
            <span className="ReviewEditButton">+65 </span>
          </Col>
          <NumberFormat
            name={field.name}
            className={
              "col-9 mobileInputbox " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            onBlur={event => {
              form.handleBlur(event)
              field.onBlur(event)
              handleTextChange(
                event,
                form.errors,
                coverageCategory,
                coverageCode
              )
            }}
            maxLength={maxLength}
            autoComplete="new-password"
            value={field.value || ""}
          />
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormMobileTextBox
